namespace common_ui {

   export class StorageSelectorModeSettings {
      showAdvancedMode:boolean;
   }
}